import { render, staticRenderFns } from "./nav-area.vue?vue&type=template&id=48e5910c&"
import script from "./nav-area.vue?vue&type=script&lang=js&"
export * from "./nav-area.vue?vue&type=script&lang=js&"
import style0 from "./nav-area.vue?vue&type=style&index=0&lang=scss&module=true&"
import style1 from "./nav-area.vue?vue&type=style&index=1&lang=css&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports